import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "订单编号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.no,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "no", $$v);
      },
      expression: "searchForm.no"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "昵称"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "所属公司"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.company,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "company", $$v);
      },
      expression: "searchForm.company"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "新开/转移"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: 0
    }
  }), _c("el-option", {
    attrs: {
      label: "新开",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "转移",
      value: 2
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "城市"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.city,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "city", $$v);
      },
      expression: "searchForm.city"
    }
  }, _vm._l(_vm.cityList, function (item) {
    return _c("el-option", {
      key: item.token,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          status: 0
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "id",
      label: "订单编号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "用户名",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "phoneNum",
      label: "手机号",
      width: "130"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "startTime",
      label: "订单开始时间",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "endTime",
      label: "订单结束时间",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [!row.actualEndTime ? _c("span", [_vm._v(_vm._s(row.endTime))]) : _c("span", {
          staticStyle: {
            color: "#ef5c61"
          }
        }, [_vm._v(_vm._s(row.endTime))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "actualEndTime",
      label: "实际结束时间",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var row = _ref3.row;
        return [!row.actualEndTime ? _c("span", [_vm._v("正常")]) : _c("span", {
          staticStyle: {
            color: "#ef5c61"
          }
        }, [_vm._v(_vm._s(row.actualEndTime))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "days",
      label: "实际天数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "amount",
      label: "金额"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "company",
      label: "所属公司"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "city",
      label: "城市"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createTime",
      label: "操作时间",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createName",
      label: "操作人"
    }
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.pageSize,
      "current-page": _vm.searchForm.pageNum,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };